<template>
  <div :class="{ 'mt-30-px': !showNavbar }">
    <notifications></notifications>
    <navbar
      v-if="showNavbar"
      :docsName="docsName"
    />

    <div class="container-fluid row">
      <div
        v-if="showNavbar"
        class="col-xl-12"
      >
        <div class="row">
          <div class="col-xl-12 block br-t-l-0 mb-3">
            <head-menu
              :col="12"
              class="d-xl-flex"
              :headline="navbarTitel ? navbarTitel : $t('global.newpresence')"
            ></head-menu>
            <div class="row mt-2">
              <div class="ml-4">
                <button
                  v-shortkey.once="['ctrl', 's']"
                  v-if="editable"
                  class="btn btn-success"
                  @click="speichern"
                  @shortkey="speichern"
                >
                  {{ $t('global.save') }}
                </button>
                <button
                  class="btn btn-primary ml-2"
                  @click="abbrechen"
                >
                  <font-awesome-icon
                    icon="fa-solid fa-list"
                    class="mr-2"
                  />
                  {{ $t('global.tolist') }}
                </button>
                <button
                  class="btn btn-primary ml-2"
                  @click="openSpracheWaehlenModal"
                  v-if="editable"
                >
                  <font-awesome-icon
                    icon="fa-duotone fa-print"
                    class="mr-1"
                  />
                  {{ $t('global.printAttendanceList') }}
                </button>
                <button
                  v-if="editable"
                  class="btn btn-primary ml-2"
                  @click="setAll100"
                >
                  {{ $t('global.allon100') }}
                </button>
              </div>
              <div
                class="ml-2"
                v-if="raster ? (raster.id ? true : false) : false"
              >
                <button
                  class="btn btn-primary"
                  @click="showUnterrichtsinhaltModal"
                >
                  <font-awesome-icon
                    icon="fa-solid fa-list"
                    class="mr-2"
                  />
                  {{ $t('global.showlessoncontent') }}
                </button>
                <button
                  class="btn btn-primary ml-2"
                  @click="showUnterrichtsplanungModal"
                >
                  <font-awesome-icon
                    icon="fa-solid fa-list"
                    class="mr-2"
                  />
                  {{ $t('global.showlessoncontentplanning') }}
                </button>
              </div>
              <button
                class="btn btn-primary ml-2"
                @click="showFachkompetenzenUebernehmenModal"
              >
                <font-awesome-icon
                  icon="fa-solid fa-list"
                  class="mr-2"
                />
                {{ $t('global.editallprofessionalskillsandsocialbehaviour') }}
              </button>

              <div class="ml-2">
                <button
                  class="btn btn-primary"
                  @click="carboneExport"
                  v-if="editable"
                >
                  <font-awesome-icon
                    icon="fa-regular fa-file-export"
                    class="mr-1"
                  />
                  {{ $t('global.export') }}
                </button>
              </div>
              <div class="mr-2"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- START Linke Seite -->

      <div
        class="col-xl-12 pr-4"
        :class="{ 'col-xl-12': !showNavbar }"
      >
        <!-- START Daten -->
        <container-headline
          :headline="$t('global.data')"
          :col="4"
        ></container-headline>

        <div class="row mb-3">
          <div class="col-xl-12 block br-t-l-0">
            <div class="eingabe-panel-kopf p-3">
              <div class="row">
                <div class="col-xl-12">
                  <div class="row">
                    <div class="col-xl-4">
                      <div class="form-group">
                        <span
                          class="openIcon"
                          v-on:click="oeffneVeranstaltung"
                          v-if="
                            berechtigungen.b_bildung_fach.read ||
                            berechtigungen.b_bildung_kurs.read
                          "
                        >
                          <font-awesome-icon
                            icon="fa-duotone fa-arrow-circle-right"
                          />
                        </span>
                        <input
                          v-model="fach"
                          class="form-control"
                          readonly
                          placeholder=" "
                        />
                        <label>
                          {{ $t('global.event') }}
                          <font-awesome-icon
                            icon="fa-duotone fa-arrow-circle-right"
                          />
                        </label>
                      </div>
                    </div>
                    <div class="col-xl-1">
                      <div class="form-group">
                        <input
                          v-model.trim="veranstaltungStatus"
                          class="form-control"
                          placeholder=" "
                          readonly="true"
                        />
                        <label>{{ $t('global.status') }}</label>
                      </div>
                    </div>
                    <div class="col-xl-1">
                      <div class="form-group">
                        <input
                          v-model.trim="datum"
                          class="form-control"
                          placeholder=" "
                          readonly="true"
                        />
                        <label>{{ $t('global.date') }}</label>
                      </div>
                    </div>
                    <div class="col-xl-1">
                      <div class="form-group">
                        <input
                          v-model.trim="uhrzeit"
                          class="form-control"
                          placeholder=" "
                          readonly="true"
                        />
                        <label>{{ $t('global.Time') }}</label>
                      </div>
                    </div>
                    <div class="col-xl-1">
                      <div class="form-group">
                        <input
                          v-model.trim="raum"
                          class="form-control"
                          placeholder=" "
                          readonly="true"
                        />
                        <label>{{ $t('global.room') }}</label>
                      </div>
                    </div>
                    <div class="col-xl-2">
                      <div class="form-group">
                        <b-dropdown
                          v-if="
                            berechtigungen.m_dozierende.read &&
                            dozentenList.length > 1
                          "
                          class="openIcon"
                          variant="link"
                          toggle-class="p-0"
                          no-caret
                          right
                        >
                          <template v-slot:button-content>
                            <font-awesome-icon
                              icon="fa-duotone fa-arrow-circle-right"
                            />
                          </template>
                          <b-dropdown-item
                            v-for="d in dozentenList"
                            :key="d.dozentenbuchungId"
                            @click="oeffneDozentenbuchungById(d.dozentenbuchungId)"
                          >
                            {{ d.name }}
                          </b-dropdown-item>
                        </b-dropdown>
                        <span
                          class="openIcon"
                          v-on:click="oeffneDozentenbuchung"
                          v-else-if="berechtigungen.m_dozierende.read"
                        >
                          <font-awesome-icon
                            icon="fa-duotone fa-arrow-circle-right"
                          />
                        </span>
                        <input
                          v-model="dozent"
                          class="form-control"
                          readonly
                          placeholder=" "
                        />
                        <label>
                          {{ $t('global.lecturer') }}
                          <font-awesome-icon
                            icon="fa-duotone fa-arrow-circle-right"
                          />
                        </label>
                      </div>
                    </div>

                    <div class="col-xl-2">
                      <div class="form-group">
                        <span
                          class="openIcon"
                          v-on:click="oeffneTermin"
                          v-if="berechtigungen.m_dozierende.read"
                        >
                          <font-awesome-icon
                            icon="fa-duotone fa-arrow-circle-right"
                          />
                        </span>
                        <input
                          v-model="termin.bezeichnung"
                          class="form-control"
                          readonly
                          placeholder=" "
                        />
                        <label>
                          {{ $t('global.appointment') }}
                          <font-awesome-icon
                            icon="fa-duotone fa-arrow-circle-right"
                          />
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ENDE Daten -->
        <!-- START Inhalt -->
        <container-headline
          :headline="$t('global.lessoncontent')"
          :col="4"
          v-if="showUnterrichtsinhalt"
        ></container-headline>

        <div
          class="row mb-3"
          v-if="showUnterrichtsinhalt"
        >
          <div class="col-xl-12 block br-t-l-0">
            <div class="eingabe-panel-kopf p-3">
              <div class="row">
                <div class="col-xl-12">
                  <div
                    v-for="(bereich, bereichKey) in selectedFachMatrix"
                    v-bind:key="bereich.id"
                    class="row"
                  >
                    <div class="col-xl-12">
                      <div class="row">
                        <div
                          class="col-xl-12"
                          style="font-weight: 600; font-size: 14pt"
                        >
                          {{ bereiche[bereichKey] }}
                        </div>
                      </div>
                      <div
                        class="row mt-2 px-3"
                        style="font-size: 12pt"
                      >
                        <div
                          v-for="(sektion, sektionKey) in bereich"
                          v-bind:key="sektion.id"
                          class="col-xl-2 p-0 px-1"
                        >
                          <div
                            @click="selectInhalt(sektionKey)"
                            class="col-xl-12 mb-3 d-flex align-items-center"
                            :class="
                              sektionenList.includes(sektionKey)
                                ? 'bg-green'
                                : 'bg-medium-blue'
                            "
                            :style="{
                              fontWeight: '600',
                              height: '60px',
                              padding: '40px 15px',
                              borderRadius: '3px',
                            }"
                          >
                            {{ sektionen[sektionKey] }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <textarea
                    v-model.trim="bemerkung_unterricht"
                    class="form-control"
                    placeholder=" "
                    :tabindex="113"
                    :readonly="!editable"
                  ></textarea>
                  <label>{{ $t('global.comment') }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ENDE Inhalt -->

        <!-- START Planung -->
        <container-headline
          :headline="$t('global.connectionplanning')"
          :col="4"
          v-if="showPlanung"
        ></container-headline>

        <div
          class="row mb-3"
          v-if="showPlanung"
        >
          <div class="col-xl-12 block br-t-l-0">
            <div class="eingabe-panel-kopf p-3">
              <div class="row">
                <div class="col-xl-12">
                  <div
                    v-for="(bereich, bereichKey) in selectedFachMatrix"
                    v-bind:key="bereich.id"
                    class="row"
                  >
                    <div class="col-xl-12">
                      <div class="row">
                        <div
                          class="col-xl-12"
                          style="font-weight: 600; font-size: 14pt"
                        >
                          {{ bereiche[bereichKey] }}
                        </div>
                      </div>
                      <div
                        class="row mt-2 px-3"
                        style="font-size: 12pt"
                      >
                        <div
                          v-for="(sektion, sektionKey) in bereich"
                          v-bind:key="sektion.id"
                          class="col-xl-2 p-0 px-1"
                        >
                          <div
                            @click="selectPlanung(sektionKey)"
                            class="col-xl-12 mb-3 d-flex align-items-center"
                            :class="
                              sektionenListPlanung.includes(sektionKey)
                                ? 'bg-green'
                                : 'bg-medium-blue'
                            "
                            style="
                              font-weight: 600;
                              height: 60px;
                              padding: 40px 15px;
                              border-radius: 3px;
                            "
                          >
                            {{ sektionen[sektionKey] }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <textarea
                    v-model.trim="bemerkung_planung"
                    class="form-control"
                    placeholder=" "
                    :tabindex="113"
                    :readonly="!editable"
                  ></textarea>
                  <label>{{ $t('global.comment') }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ENDE Planung -->
        <!-- START Reiter -->

        <container-headline
          :headline="$t('global.participants')"
          :col="4"
        >
          <div class="col-xl-6 ml-auto d-flex pr-0">
            <div class="mr-2 ml-auto">
              <button
                type="button"
                size="sm"
                @click="expandAll"
                class="btn btn-primary btn-sm"
              >
                {{ $t('global.showallremarks') }}
              </button>
            </div>
            <div class="">
              <button
                type="button"
                size="sm"
                @click="collapseAll"
                class="btn btn-primary btn-sm"
              >
                {{ $t('global.hideallremarks') }}
              </button>
            </div>
          </div>
        </container-headline>

        <div class="row mb-3">
          <div class="col-xl-12 block belegliste br-t-l-0">
            <div>
              <b-table
                ref="selectableTable"
                tbody-tr-class="item"
                :items="anwesenheit"
                :fields="fields"
                sort-icon-left
                fixed
              >
                <template v-slot:cell(redirectPerson)="row">
                  <b-button
                    size="sm"
                    @click="redirectToPerson(row.item.anmeldung.person.id)"
                    variant="outline-primary"
                  >
                    <font-awesome-icon icon="fa-regular fa-arrow-up-right" />
                  </b-button>
                </template>

                <template v-slot:cell(redirect)="row">
                  <b-button
                    size="sm"
                    @click="redirectToRegistration(row.item.anmeldung.id)"
                    variant="outline-primary"
                  >
                    <font-awesome-icon icon="fa-regular fa-arrow-up-right" />
                  </b-button>
                </template>

                <template v-slot:cell(anwesenheit)="row">
                  <div class="mb-2 d-flex justify-content-between">
                    <b-button
                      class="w-30-p"
                      :variant="
                        row.item.anwesenheitsrate == 100 &&
                        !istStatusOffen(row.item)
                          ? 'primary'
                          : 'light'
                      "
                      size="sm"
                      @click="setAnwesenheit(100, row.item)"
                    >
                      100%
                    </b-button>
                    <b-button
                      class="w-30-p"
                      :variant="
                        row.item.anwesenheitsrate == 50 &&
                        !istStatusOffen(row.item)
                          ? 'primary'
                          : 'light'
                      "
                      size="sm"
                      @click="setAnwesenheit(50, row.item)"
                    >
                      50%
                    </b-button>
                    <b-button
                      class="w-30-p"
                      :variant="
                        row.item.anwesenheitsrate == 0 &&
                        !istStatusOffen(row.item)
                          ? 'primary'
                          : 'light'
                      "
                      size="sm"
                      @click="setAnwesenheit(0, row.item)"
                    >
                      0%
                    </b-button>
                  </div>
                  <div
                    class="mb-2 d-flex justify-content-between"
                    v-if="
                      row.item.anwesenheitsrate != 0 &&
                      row.item.anwesenheitsrate != 50 &&
                      row.item.anwesenheitsrate != 100 &&
                      row.item.anwesenheitsrate != null &&
                      !istStatusOffen(row.item)
                    "
                  >
                    <b-button
                      class="w-100-p"
                      variant="primary"
                      size="sm"
                    >
                      {{ row.item.anwesenheitsrate }}%
                    </b-button>
                  </div>
                  <div class="d-flex justify-content-between">
                    <b-button
                      class="mb-2 w-48-p fs-11"
                      :disabled="
                        row.item.anwesenheitsrate == 100 ||
                        row.item.anwesenheitsrate == 0 ||
                        row.item.anwesenheitsrate === null
                      "
                      :variant="
                        row.item.teilpraesenz &&
                        row.item.teilpraesenz.id == '188E8499D89'
                          ? 'primary'
                          : 'light'
                      "
                      size="sm"
                      @click="setTeilpraesenz('188E8499D89', row.item)"
                    >
                      {{ $t('global.latemorning') }}
                    </b-button>
                    <b-button
                      class="mb-2 w-48-p fs-11"
                      :disabled="
                        row.item.anwesenheitsrate == 100 ||
                        row.item.anwesenheitsrate == 0 ||
                        row.item.anwesenheitsrate === null
                      "
                      :variant="
                        row.item.teilpraesenz &&
                        row.item.teilpraesenz.id == '188E849BB56'
                          ? 'primary'
                          : 'light'
                      "
                      size="sm"
                      @click="setTeilpraesenz('188E849BB56', row.item)"
                    >
                      {{ $t('global.afternoon') }}
                    </b-button>
                  </div>
                </template>
                <template v-slot:cell(abwesenheit)="row">
                  <b-button
                    class="col-xl-5 col-lg-10 mr-2 mb-2"
                    :variant="
                      row.item.praesenzstatus.id ==
                      $CONST('PRAESENZSTATI').EXCUSED
                        ? 'primary'
                        : 'light'
                    "
                    size="sm"
                    @click="
                      setPraesenzStatus(
                        $CONST('PRAESENZSTATI').EXCUSED,
                        row.item
                      )
                    "
                  >
                    {{ $t('global.excused') }}
                  </b-button>
                  <b-button
                    class="col-xl-5 col-lg-10 mr-2 mb-2"
                    :variant="
                      row.item.praesenzstatus.id ==
                      $CONST('PRAESENZSTATI').UNEXCUSED
                        ? 'primary'
                        : 'light'
                    "
                    size="sm"
                    @click="
                      setPraesenzStatus(
                        $CONST('PRAESENZSTATI').UNEXCUSED,
                        row.item
                      )
                    "
                  >
                    {{ $t('global.unexcused') }}
                  </b-button>
                  <b-button
                    class="col-xl-5 col-lg-10 mr-2 mb-2"
                    :variant="
                      row.item.praesenzstatus.id ==
                      $CONST('PRAESENZSTATI').DISPENSED
                        ? 'primary'
                        : 'light'
                    "
                    size="sm"
                    @click="
                      setPraesenzStatus(
                        $CONST('PRAESENZSTATI').DISPENSED,
                        row.item
                      )
                    "
                  >
                    {{ $t('global.dispensed') }}
                  </b-button>
                  <b-button
                    class="col-xl-5 col-lg-10 mr-2 mb-2"
                    :variant="
                      row.item.praesenzstatus.id ==
                      $CONST('PRAESENZSTATI').JOKERDAY
                        ? 'primary'
                        : 'light'
                    "
                    size="sm"
                    @click="
                      setPraesenzStatus(
                        $CONST('PRAESENZSTATI').JOKERDAY,
                        row.item
                      )
                    "
                  >
                    {{ $t('global.jokerday') }}
                  </b-button>
                  <b-button
                    class="col-xl-10 col-lg-10 ml-xl-1 mb-2"
                    :variant="
                      row.item.praesenzstatus.id ==
                      $CONST('PRAESENZSTATI').PARTLY_ATTENDED
                        ? 'primary'
                        : 'light'
                    "
                    size="sm"
                    @click="
                      setPraesenzStatus(
                        $CONST('PRAESENZSTATI').PARTLY_ATTENDED,
                        row.item
                      )
                    "
                  >
                    {{ $t('global.partly_attended') }}
                  </b-button>
                </template>
                <template v-slot:cell(note)="row">
                  <div class="form-group m-0 p-0 col-xl-4">
                    <div
                      class="form-group"
                      style="padding-top: 8px"
                    >
                      <input
                        v-model.trim="row.item.note"
                        class="form-control"
                        :readonly="!editable"
                        placeholder=" "
                        :tabindex="203"
                      />
                    </div>
                  </div>
                </template>
                <template #cell(kompetenzraster)="row">
                  <b-button
                    type="button"
                    size="sm"
                    style="width: 150px"
                    @click="showKompetenzraster(row.item)"
                  >
                    {{ $t('global.competencegrid') }}
                  </b-button>
                </template>
                <!-- TODO bitte wie bei notenübersicht -->
                <template #cell(edit)="row">
                  <div class="d-flex align-items-center">
                    <span class="d-flex justify-content-center">
                      <button
                        type="button"
                        size="sm"
                        @click="row.toggleDetails"
                        class="btn btn-primary btn-sm"
                      >
                        <span
                          v-if="
                            row.item.sozialverhalten || row.item.fachkompetenzen
                          "
                        >
                          *
                        </span>
                        {{
                          row.detailsShowing
                            ? $t('global.hide')
                            : $t('global.show')
                        }}
                        <font-awesome-icon
                          :icon="
                            row.detailsShowing
                              ? 'fa-chevron-up'
                              : 'fa-chevron-down'
                          "
                        />
                      </button>
                    </span>
                  </div>
                </template>
                <template #row-details="row">
                  <b-card>
                    <div class="d-flex flex-column">
                      <span class="row mb-4 d-flex align-items-center">
                        <span
                          sm="3"
                          class="col-2 text-sm-right fs-12"
                        >
                          <b>
                            {{
                              $t('global.commentonsubjectprofessionalskills')
                            }}
                          </b>
                        </span>
                        <textarea
                          :readonly="!editable"
                          class="col-12 input-lg"
                          type="text"
                          :placeholder="
                            $t('global.commentonsubjectprofessionalskills')
                          "
                          v-model="row.item.fachkompetenzen"
                          :disabled="bearbeitungGesperrt"
                        />

                        <!-- <div
                          class="col-3 btn btn-primary mb-4 ml-auto mr-3"
                          style="width: 200px"
                          v-if="row.item.anmeldungIdSemester != ''"
                          @click="showLernzielvereinbarungBewertung(row.item)"
                        >
                          {{ $t("global.learningobjectivesagreement") }}
                        </div> -->
                      </span>

                      <span class="row mb-2 d-flex align-items-center">
                        <span
                          sm="3"
                          class="col-2 text-sm-right fs-12"
                        >
                          <b>{{ $t('global.commentonworksocialbehavior') }}</b>
                        </span>
                        <textarea
                          :readonly="!editable"
                          class="col-12 input-lg"
                          type="text"
                          :placeholder="
                            $t('global.commentonworksocialbehavior')
                          "
                          v-model="row.item.sozialverhalten"
                          :disabled="bearbeitungGesperrt"
                        />

                        <!-- <div
                          v-if="berechtigungen.b_bildung_anwesenheit.update"
                          class="col-3 btn btn-primary mb-4 ml-auto mr-3"
                          style="width: 200px"
                          @click="
                            KompetenzenUndVerhaltenFuerAlleUebernehmen(row.item)
                          "
                        >
                          {{ $t("global.applyforall") }}
                        </div> -->
                      </span>
                    </div>
                  </b-card>
                </template>

                <template #cell(editSozial)="row2">
                  <div class="d-flex align-items-center">
                    <div
                      class="d-flex"
                      style="position: relative"
                    >
                      <span
                        class="d-flex justify-content-center ml-auto mr-auto"
                      >
                        <button
                          type="button"
                          size="sm"
                          @click="row2.toggleDetails"
                          class="btn btn-primary btn-sm"
                        >
                          <span
                            v-if="
                              row2.item.sozialverhalten ||
                              row2.item.fachkompetenzen
                            "
                          >
                            *
                          </span>
                          {{
                            row2.detailsShowing
                              ? $t('global.hide')
                              : $t('global.show')
                          }}
                          <font-awesome-icon
                            :icon="
                              row2.detailsShowing
                                ? 'fa-chevron-up'
                                : 'fa-chevron-down'
                            "
                          />
                        </button>
                      </span>
                      <span
                        class="d-flex justify-content-center p-1"
                        style="position: absolute; left: 72%"
                      ></span>
                    </div>
                  </div>
                </template>
                <template
                  #head(editKompetenzen)
                  v-if="raster ? (raster.id ? true : false) : false"
                >
                  <span>
                    {{ $t('global.lessoncontent') }}
                  </span>
                </template>

                <template #cell(editKompetenzen)="row">
                  <div class="d-flex align-items-center">
                    <span
                      class="d-flex justify-content-center"
                      v-if="raster ? (raster.id ? true : false) : false"
                    >
                      <button
                        type="button"
                        size="sm"
                        @click="showUnterrichtsinhaltPersonModal(row.item)"
                        class="btn btn-primary btn-sm"
                      >
                        {{ $t('global.content') }}
                      </button>
                    </span>
                  </div>
                </template>
                <!--
				  <template #row2-details="row2">
					<b-card>
					  <span class="row mb-2">
						<span sm="3" class="col-2 text-sm-right"
						  ><b>Bemerkung: </b></span
						>
						<textarea
						  class="col-8 input-lg"
						  type="text"
						  placeholder="Bemerkung"
						  v-model="row2.item.sozialverhalten"
						  :disabled="bearbeitungGesperrt"
						/>
					  </span>
					</b-card>
				  </template>-->
              </b-table>
            </div>
          </div>
        </div>

        <!-- ENDE linke Seite -->
      </div>
    </div>

    <fachkompetenzen-uebernehmen-modal
      :id="'fachkompetenzen-uebernehmen-modal'"
      @confirmed="uebernehmen"
    />

    <messagebox
      id="dupletten-msg-box"
      ref="duplettenMsgBox"
      :header-text="$t('global.conflictwithjokerday')"
      ok
    >
      <p>{{ $t('global.thereisaconflictwithjokerday') }}</p>
      <div class="row"></div>
    </messagebox>

    <loading-overlay v-show="loading"></loading-overlay>

    <lernzielvereinbarung-bewertung-modal
      :editable="false"
      :id="LernzielvereinbarungBewertungModalId"
      :anmeldungId="anmeldungId"
    ></lernzielvereinbarung-bewertung-modal>

    <lektionsInhalt-modal
      :editable="false"
      :id="LektionsInhaltModalId"
      :termin="this.termin"
      :veranstaltungID="this.vid"
      :rasterID="this.raster.id"
      :selectedFach="this.selectedFach"
      :anmeldungId="anmeldungId"
      :veranstaltungNiveau="
        this.veranstaltung.niveau ? this.veranstaltung.niveau.id : null
      "
      :praesenzProp="praesenz"
      :istInhalt="istInhalt"
      :istPlanung="istPlanung"
      :istPerson="istPerson"
      :key="lektionsInhaltModalKey"
      @changed="resetPraesenz"
    ></lektionsInhalt-modal>

    <kompetenzraster-bewertung-modal
      :id="KompetenzrasterBewertungModalId + termin.id"
      @kompetenzrasterDrucken="kompetenzrasterDrucken"
      @kompetenzrasterVorlageDrucken="kompetenzrasterVorlageDrucken"
    ></kompetenzraster-bewertung-modal>

    <!-- TODO: Sprachvariabeln -->
    <sprache-waehlen-modal
      :id="'praesenzliste-drucken-modal'"
      :headerText="'Präsenzliste konfigurieren'"
      :okText="$t('global.viewpdf')"
      :selectDate="false"
      :languages="['DE', 'FR']"
      @ok="praesenzlisteDrucken"
    />

    <pdf-layer
      id="pdf-layer"
      ref="pdfLayerAnwesenheit"
      :src="{
        url: pdfPath,
        withCredentials: true,
      }"
    ></pdf-layer>

    <unsaved-changes-modal
      @discard="handleDiscard"
      @stay="handleStay"
      :saveFunction="speichern"
    />
  </div>
</template>

<script>
  import HeadMenu from '@/components/HeadMenu'
  import ContainerHeadline from '@/components/ContainerHeadline'
  import Navbar from '@/components/Navbar'
  import CarboneApi from '@/api/CarboneApi'
  import LernzielvereinbarungBewertungModal from '@/components/Modals/LernzielvereinbarungBewertungModal'
  import LektionsInhaltModal from '@/components/Modals/LektionsinhaltModal'
  import KompetenzrasterBewertungModal from '@/components/Modals/KompetenzrasterBewertungModal'
  import FachkompetenzenUebernehmenModal from '@/components/Modals/FachkompetenzenUebernehmenModal'
  import FileDownload from 'js-file-download'
  import SpracheWaehlenModal from '@/components/Modals/SpracheWaehlenModal.vue'

  import Api from '@/api/Api'
  import store from '@/store'
  import page from '@/mixins/Page'
  import server from '@/server'

  import { LADE_AUSWAHLWERTE_PRAESENZ } from '@/store/praesenz/actions.type'

  import ChangeWatcherNew from '@/mixins/ChangewatcherNew'
  import UnsavedChangesModal from '@/components/Modals/UnsavedChangesModal.vue'

  export default {
    name: 'Anwesenheit',
    components: {
      HeadMenu,
      Navbar,
      ContainerHeadline,
      LernzielvereinbarungBewertungModal,
      LektionsInhaltModal,
      FachkompetenzenUebernehmenModal,
      KompetenzrasterBewertungModal,
      SpracheWaehlenModal,
      UnsavedChangesModal,
    },
    metaInfo() {
      return {
        titleTemplate: () => {
          return this.$t('global.dashboard_presence')
        },
      }
    },
    mixins: [page, ChangeWatcherNew],
    store,
    props: {
      vid: {
        type: String,
        default: null,
      },
      tid: {
        type: String,
        default: null,
      },
      anzeige: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        lektionsInhaltModalKey: 0,
        pdfPath: '',
        veranstaltungStatus: this.$t('global.notlinked'),
        anmeldungId: '',
        praesenz: null,
        istInhalt: false,
        istPlanung: false,
        istPerson: false,
        LernzielvereinbarungBewertungModalId:
          'lernzielvereinbarung-bewertung-modal',
        LektionsInhaltModalId: 'lektionsInhalt-modal',
        KompetenzrasterBewertungModalId: 'kompetenzraster-bewertung-modal',
        page: 0,
        infiniteId: +new Date(),
        anzahlProPage: 25,
        veranstaltung: {},
        oldAnwesenheit: null,
        anwesenheit: null,
        termin: { bezeichnung: '' },
        dozentenbuchung: null,
        dozenteneinsatz: null,
        dozenteneinsatzListe: [],
        dozentenList: [],
        fachkompetenzen: null,
        sozialverhalten: null,
        bemerkung_unterricht: null,
        bemerkung_planung: null,
        fachkompetenzAll: null,
        sozialverhaltenAll: null,

        fach: '',
        datum: '',
        uhrzeit: '',
        raum: '',
        dozent: '',

        editable: false,
        bearbeitungGesperrt: false,

        raster: {},
        matrix: [],
        selectedFach: [],
        reverseMatrix: {},
        faecher: {},
        bereiche: {},
        sektionen: {},
        subsektionen: {},
        stufen: {},

        selected: [],
        selectedIds: [],
        selectedInhalt: [],
        sektionenList: [],
        sektionenListPlanung: [],
        kompetenzliste: [],

        showUnterrichtsinhalt: false,
        showUnterrichtsinhaltPerson: false,
        showPlanung: false,
        /*teilpraesenzen: [
		  { id: "188E8499D89", bezeichnung: "Vormittag" },
		  { id: "188E849BB56", bezeichnung: "Nachmittag" },
		],*/
      }
    },
    computed: {
      fields() {
        const baseFields = [
          {
            key: 'anmeldung.person.personName',
            sortable: true,
            label: this.$t('global.person'),
          },
          {
            key: 'anwesenheit',
            sortable: true,
            label: this.$t('global.dashboard_presence'),
            tdClass: 'w-10',
          },
          {
            key: 'abwesenheit',
            sortable: true,
            label: this.$t('global.absence'),
            tdClass: 'w-25',
          },
          { key: 'note', sortable: true, label: this.$t('global.grade') },
          {
            key: 'editSozial',
            sortable: false,
            label: this.$t('global.competencies_behaviour'),
          },
          {
            key: 'editKompetenzen',
            sortable: false,
            label: '',
          },
        ]

        // Conditionally add the redirectPerson and redirect fields based on permissions
        if (this.berechtigungen.m_geschaeftspartner.read) {
          baseFields.splice(1, 0, {
            key: 'redirectPerson',
            sortable: true,
            label: this.$t('global.totheperson'),
            tdClass: 'text-center',
          })
          baseFields.splice(2, 0, {
            key: 'redirect',
            sortable: true,
            label: this.$t('global.registration'),
            tdClass: 'text-center',
          })
          if (this.kompetenzliste.length > 0) {
            baseFields.splice(6, 0, {
              key: 'kompetenzraster',
              sortable: false,
              label: this.$t('global.competencegrid'),
            })
          }
        }

        return baseFields
      },
      navbarTitel: function () {
        if (this.vid && this.tid) {
          return (
            this.fach +
            (this.datum ? ' ' + this.$t('global.on') + ' ' + this.datum : '') +
            (this.uhrzeit
              ? ' ' + this.$t('global.at') + ' ' + this.uhrzeit
              : '')
          )
        } else {
          return this.$t('global.newpresence')
        }
      },
      selectedFachMatrix: function () {
        return this.reverseMatrix[this.selectedFach]
      },
      teilpraesenzen: {
        get() {
          return this.$store.state.praesenz.teilpraesenzen
        },
      },
    },
    watch: {},
    created() {
      if (this.teilpraesenzen.length == 0) {
        this.$store.dispatch(`praesenz/${LADE_AUSWAHLWERTE_PRAESENZ}`)
      }

      if (this.vid && this.tid) {
        this.loading = true

        Api.get('/bildung/praesenzverwaltung/', {
          params: { veranstaltung: this.vid, termin: this.tid },
        }).then((response) => {
          this.initializeAnwesenheit(response.data)
        })
      }
    },
    mounted: function () {},
    methods: {
      resetPraesenz() {
        this.lektionsInhaltModalKey++
        this.praesenz = null
        this.istInhalt = null
        this.istPlanung = null
      },
      initializeAnwesenheit(anwesenheit) {
        if (anwesenheit) {
          this.veranstaltung = anwesenheit.veranstaltung
          this.termin = anwesenheit.termin
          this.bemerkung_unterricht = anwesenheit.termin.bemerkung_unterricht
          this.bemerkung_planung = anwesenheit.termin.bemerkung_planung
          // Datensätze ohne Status-Verweis auf "Offen" normalisieren, sonst wirft das Template bei praesenzstatus.id
          anwesenheit.praesenzliste.forEach((praesenz) => {
            if (!praesenz.praesenzstatus)
              praesenz.praesenzstatus = { id: '17646E707EB' }
          })
          this.oldAnwesenheit = JSON.parse(
            JSON.stringify(anwesenheit.praesenzliste)
          ) // Man kann auch über this.anwesenheit loopen und die Werte in ein neues Array pushen, um die Verknüpfung der Objekte aufzuheben
          this.anwesenheit = anwesenheit.praesenzliste
          this.dozenteneinsatz = anwesenheit.dozenteneinsatz
          this.dozenteneinsatzListe =
            anwesenheit.dozenteneinsatzliste ||
            (anwesenheit.dozenteneinsatz ? [anwesenheit.dozenteneinsatz] : [])
          anwesenheit.termin.unterrichtsinhalt.forEach((element) =>
            this.sektionenList.push(element.id)
          )
          anwesenheit.termin.anschlussplanung.forEach((element) =>
            this.sektionenListPlanung.push(element.id)
          )

          this.veranstaltungStatus =
            anwesenheit.veranstaltung.veranstaltungsstatus.bezeichnung

          this.dozentenList = this.dozenteneinsatzListe
            .filter((de) => de.dozentenbuchung && de.dozentenbuchung.person)
            .map((de) => ({
              name: de.dozentenbuchung.person.personName,
              dozentenbuchungId: de.dozentenbuchung.id,
            }))

          this.dozent = this.dozentenList.map((d) => d.name).join(', ')
          this.dozentenbuchung = this.dozentenList.length
            ? this.dozentenList[0].dozentenbuchungId
            : null

          this.fach = this.veranstaltung.title
          this.datum = this.termin.von
          this.uhrzeit = this.termin.von_uhrzeit

          if (this.termin.raumliste && this.termin.raumliste.length > 0)
            this.raum = this.termin.raumliste[0].bezeichnung
          else this.raum = ''

          this.initializeChangewatcher(['anwesenheit'])
        } else {
          console.error('anwesenheit ist null')
        }

        this.editable = this.berechtigungen.m_anwesenheit.update

        this.loading = false
        this.loadRaster()
      },

      redirectToRegistration(id) {
        this.$router.push({
          name: 'anmeldung',
          params: { anmeldungid: id, anzeige: 0 },
        })
      },
      redirectToPerson(id) {
        this.$router.push({
          name: 'geschaeftspartner',
          params: { id: id, anzeige: 0 },
        })
      },
      selectInhalt(sektionObj) {
        if (this.sektionenList.includes(sektionObj)) {
          let indexOfObject = this.sektionenList.findIndex((object) => {
            return object == sektionObj
          })
          this.sektionenList.splice(indexOfObject, 1)
        } else {
          this.sektionenList.push(sektionObj)
        }
      },
      selectPlanung(sektionObj) {
        if (this.sektionenListPlanung.includes(sektionObj)) {
          let indexOfObject = this.sektionenListPlanung.findIndex((object) => {
            return object == sektionObj
          })
          this.sektionenListPlanung.splice(indexOfObject, 1)
        } else {
          this.sektionenListPlanung.push(sektionObj)
        }
      },
      toggleUnterrichtsinhalt() {
        if (this.showUnterrichtsinhalt) {
          this.showUnterrichtsinhalt = false
        } else {
          this.showUnterrichtsinhalt = true
        }
      },
      toggleUnterrichtsinhaltPerson() {
        if (this.showUnterrichtsinhaltPerson) {
          this.showUnterrichtsinhaltPerson = false
        } else {
          this.showUnterrichtsinhaltPerson = true
        }
      },
      togglePlanung() {
        if (this.showPlanung) {
          this.showPlanung = false
        } else {
          this.showPlanung = true
        }
      },
      loadRaster() {
        if (!this.veranstaltung.fach) return

        this.loading = true

        Api.get('bildung/kompetenzraster/', {
          params: {
            fachID: this.veranstaltung.fach?.id,
          },
        }).then((response) => {
          this.initializeRaster(response.data[0])
        })
      },

      initializeRaster(raster) {
        if (raster) {
          this.raster = raster
          Api.get('bildung/kompetenzraster/kompetenzdefinition/', {
            params: { rasterid: this.raster.id },
          }).then((response) => {
            this.initializeMatrix(response?.data)
          })
        } else {
          console.error('kompetenzraster ist null')
        }

        this.loading = false
      },
      initializeMatrix(matrix) {
        if (matrix) {
          this.matrix = matrix

          this.selectedFach = null

          this.matrix.forEach((definition) => {
            let subsektion = definition.subsektion
            let sektion = definition.sektion
            let bereich = definition.bereich
            let fach = definition.fach

            if (!this.faecher[fach?.id]) this.faecher[fach?.id] = fach
            if (!this.selectedFach) this.selectedFach = fach?.id

            if (!this.reverseMatrix[fach?.id]) this.reverseMatrix[fach?.id] = {}

            if (!this.reverseMatrix[fach?.id][bereich?.id]) {
              this.reverseMatrix[fach?.id][bereich?.id] = {}
              this.bereiche[bereich?.id] = bereich?.bezeichnung
            }

            if (!this.reverseMatrix[fach?.id][bereich?.id][sektion?.id]) {
              this.reverseMatrix[fach?.id][bereich?.id][sektion?.id] = {}
              this.sektionen[sektion?.id] = sektion?.bezeichnung
            }

            if (
              !this.reverseMatrix[fach?.id][bereich?.id][sektion?.id][
                subsektion?.id
              ]
            ) {
              this.reverseMatrix[fach?.id][bereich?.id][sektion?.id][
                subsektion?.id
              ] = {}
              this.subsektionen[subsektion?.id] = subsektion?.bezeichnung
            }

            if (
              !this.reverseMatrix[fach?.id][bereich?.id][sektion?.id][
                subsektion?.id
              ]
            ) {
              this.reverseMatrix[fach?.id][bereich?.id][sektion?.id][
                subsektion?.id
              ] = {}
              //this.stufen[definition.stufe.id] = definition.stufe.bezeichnung;
            }

            this.reverseMatrix[fach?.id][bereich?.id][sektion?.id][
              subsektion?.id
            ][definition.id] = definition
          })

          this.fachSelect++
        } else {
          console.error('kompetenzmastrix ist null')
        }
      },

      setAll100() {
        if (!this.editable) return

        if (
          this.veranstaltung &&
          this.veranstaltung.veranstaltungsstatus.id ==
            this.$CONST('VERANSTALTUNGSSTATI').OPEN
        ) {
          this.anwesenheit.forEach((anwesenheit) => {
            this.$set(anwesenheit, 'anwesenheitsrate', 100)
            this.$set(anwesenheit, 'teilpraesenz', null)
            this.$set(
              anwesenheit.praesenzstatus,
              'id',
              this.$CONST('PRAESENZSTATI').ATTENDED
            )
          })
        } else {
          this.$notify({
            type: 'warning',
            title: this.$t('global.actionfailed'),
            text:
              this.$t('global.edititingdatanotyetapproved') +
              '\n' +
              this.$t('global.checkthestatus'),
          })
        }
      },
      speichern() {
        if (this.loading) return
        this.loading = true
        // Hier über this.anwesenheit loopen und neues Array nur mit denjenigen Präsenzen, die verändert wurden anlegen, welche im JSON mitgegeben wird.
        let praesenzen = []
        //for (let counter = 0; counter <= this.anwesenheit.length - 1; counter++) {
        // if (
        //   this.anwesenheit[counter].fachkompetenzen !==
        //     this.oldAnwesenheit[counter].fachkompetenzen ||
        //   this.anwesenheit[counter].sozialverhalten !==
        //     this.oldAnwesenheit[counter].sozialverhalten
        // ) {
        //praesenzen.push(this.anwesenheit[counter]);
        //} MTO 24-08-23
        //}

        var json = {
          praesenzliste:
            praesenzen.length !== 0 ? praesenzen : this.anwesenheit,
          dozenteneinsatz: this.dozenteneinsatz,
          dozenteneinsatzliste: this.dozenteneinsatzListe,
          kompetenzliste: this.kompetenzliste,
          bemerkung_unterricht: this.bemerkung_unterricht,
          bemerkung_planung: this.bemerkung_planung,
        }

        Api.put('/bildung/praesenzverwaltung/', json, {
          params: { veranstaltung: this.vid, termin: this.tid },
        })
          .then((response) => {
            if (!response.data.error) {
              this.initializeAnwesenheit(response.data)
              this.$notify({
                type: 'success',
                title: this.$t('global.actionsuccessful'),
                text: this.$t('global.presencesuccessfullysaved'),
              })
            }
            //this.disableChangeWatcher(this.anwesenheit);
          })
          .catch((e) => {
            //this.$notify(apiErrorToAlert(e));
            this.$notify({
              type: 'warning',
              title: this.$t('global.actionfailed'),
              text: this.$t('global.jokerdaydoesnotmatch'),
            })
            this.$refs.duplettenMsgBox.openModal()
          })
          .finally(() => {
            this.loading = false
          })
      },
      abbrechen() {
        this.$router.push({ name: 'Anwesenheitsliste' })
      },
      setPraesenzStatus(status, item) {
        if (!this.editable) return

        // Ohne konfigurierten Status (fehlender AppKey am System) würde eine undefined-ID
        // gesetzt und beim Speichern der Praesenzstatus in der Datenbank geleert
        if (!status) {
          this.$notify({
            type: 'warning',
            title: this.$t('global.actionfailed'),
            text: 'Der Präsenzstatus ist auf diesem System nicht konfiguriert.',
          })
          return
        }

        if (
          this.veranstaltung &&
          this.veranstaltung.veranstaltungsstatus.id ==
            this.$CONST('VERANSTALTUNGSSTATI').OPEN
        ) {
          this.$set(item.praesenzstatus, 'id', status)

          if (item.anwesenheitsrate != 50) {
            this.$set(item, 'anwesenheitsrate', 0)
            this.$set(item, 'teilpraesenz', null)
          }

          if (status == this.$CONST('PRAESENZSTATI').PARTLY_ATTENDED) {
            this.$set(item, 'anwesenheitsrate', 100)
            this.$set(item, 'teilpraesenz', null)
          }
        } else {
          this.$notify({
            type: 'warning',
            title: this.$t('global.actionfailed'),
            text:
              this.$t('global.edititingdatanotyetapproved') +
              '\n' +
              this.$t('global.checkthestatus'),
          })
        }
      },

      setNote(note, index) {
        if (!this.editable) return
        this.anwesenheit[index].note = note
      },

      istStatusOffen(item) {
        return item.praesenzstatus && item.praesenzstatus.id == '17646E707EB' // Offen
      },

      setAnwesenheit(rate, item) {
        if (!this.editable) return

        if (
          this.veranstaltung &&
          this.veranstaltung.veranstaltungsstatus.id ==
            this.$CONST('VERANSTALTUNGSSTATI').OPEN
        ) {
          // Bei Status "Offen" ist keine Rate ausgewählt -> Klick setzt neu statt abzuwählen
          if (rate === item.anwesenheitsrate && !this.istStatusOffen(item)) {
            this.$set(item, 'anwesenheitsrate', null)
            this.$set(item, 'teilpraesenz', null)
            this.$set(item.praesenzstatus, 'id', '17646E707EB')
          } else {
            if (rate != 50) {
              this.$set(item, 'teilpraesenz', null)
            }
            this.$set(item, 'anwesenheitsrate', rate)
            this.$set(
              item.praesenzstatus,
              'id',
              rate == 0
                ? this.$CONST('PRAESENZSTATI').UNEXCUSED
                : this.$CONST('PRAESENZSTATI').ATTENDED
            )
          }
        } else {
          this.$notify({
            type: 'warning',
            title: this.$t('global.actionfailed'),
            text:
              this.$t('global.edititingdatanotyetapproved') +
              '\n' +
              this.$t('global.checkthestatus'),
          })
        }
      },
      setTeilpraesenz(teilpraesenzID, item) {
        if (!this.editable) return

        if (this.veranstaltung)
          if (
            this.veranstaltung.veranstaltungsstatus.id ==
            this.$CONST('VERANSTALTUNGSSTATI').OPEN
          ) {
            const teilpraesenz = this.teilpraesenzen.find(
              (tp) => tp.id === teilpraesenzID
            )
            this.$set(item, 'teilpraesenz', teilpraesenz)
            this.$set(
              item.praesenzstatus,
              'id',
              this.$CONST('PRAESENZSTATI').ATTENDED
            )
          } else {
            this.$notify({
              type: 'warning',
              title: this.$t('global.actionfailed'),
              text:
                this.$t('global.edititingdatanotyetapproved') +
                '\n' +
                this.$t('global.checkthestatus'),
            })
          }
      },
      oeffneDozentenbuchung() {
        this.$router.push({
          name: 'dozentenbuchung',
          params: { id: this.dozentenbuchung, anzeige: 0 },
        })
      },
      oeffneDozentenbuchungById(id) {
        this.$router.push({
          name: 'dozentenbuchung',
          params: { id: id, anzeige: 0 },
        })
      },
      oeffneTermin() {
        this.$router.push({
          name: 'termin',
          params: { id: this.termin.id, anzeige: 0 },
        })
      },
      oeffneVeranstaltung() {
        let typ = ''
        let idName = ''

        // Werte für Route entsprechend Veranstaltungstyp setzten
        switch (this.veranstaltung.veranstaltungstyp.id) {
          case '174D91487D4': //ID Typ Fach
            typ = 'fach'
            idName = 'fachid'
            break
          case '174D91487D8': //ID Typ Event
            typ = 'event'
            idName = 'eventid'
            break
          case '174D91487E6': //ID Typ Informationsanlass
            typ = 'infoanlass'
            idName = 'infoanlassid'
            break
          case '174D91487E8': //ID Typ Kurs
            typ = 'kurs'
            idName = 'kursid'
            break
          case '1922E5C1FC3': //ID Typ Kurzveranstaltung
            typ = 'Kurzveranstaltung'
            idName = 'kurzveranstaltungid'
            break
          default:
            typ = 'fach'
            idName = 'fachid'
        }

        this.$router.push({
          name: typ,
          params: { [idName]: this.vid, anzeige: 0 },
        })
      },

      showLernzielvereinbarungBewertung(anwesenheit) {
        this.anmeldungId = anwesenheit?.anmeldungIdSemester // nötig? wird unten zugeordnet

        this.$bus.$emit('openLernzielvereinbarungBewertungModal', {
          modalId: 'lernzielvereinbarung-bewertung-modal',
          anmeldungId: anwesenheit?.anmeldungIdSemester,
        })
      },
      showKompetenzraster(anwesenheit) {
        //this.anmeldungId = anwesenheit?.anmeldungIdSemester;
        this.$bus.$emit('openKompetenzrasterBewertungModal', {
          id: 'kompetenzraster-bewertung-modal' + this.termin.id,
          anmeldungId: anwesenheit?.anmeldungIdSemester,
          anmeldung: anwesenheit?.anmeldung,
        })
      },
      showUnterrichtsinhaltPersonModal(praesenz) {
        this.praesenz = praesenz
        this.istPlanung = false
        this.istInhalt = false
        this.istPerson = true

        this.$bus.$emit('openLektionsInhaltModal', {
          modalId: 'lektionsInhalt-modal',
          praesenzID: praesenz.id,
          istPerson: true,
        })
      },
      showUnterrichtsinhaltModal() {
        this.istPlanung = false
        this.istInhalt = true
        this.istPerson = false
        this.$bus.$emit('openLektionsInhaltModal', {
          modalId: 'lektionsInhalt-modal',
          istPlanung: false,
          istInhalt: true,
        })
      },
      showUnterrichtsplanungModal() {
        this.istPlanung = true
        this.istInhalt = false
        this.istPerson = false
        this.$bus.$emit('openLektionsInhaltModal', {
          modalId: 'lektionsInhalt-modal',
          istInhalt: false,
          istPlanung: true,
        })
      },
      showFachkompetenzenUebernehmenModal() {
        this.$bus.$emit('open-modal', 'fachkompetenzen-uebernehmen-modal')
      },
      uebernehmen(json) {
        if (json.fachkompetenz || json.sozialverhalten) {
          this.anwesenheit.forEach((praesenz) => {
            // Hässliche Formattierung muss so, damits im Feld stimmt
            if (json.fachkompetenz && praesenz.fachkompetenzen !== null) {
              if (praesenz.fachkompetenzen !== '') {
                praesenz.fachkompetenzen = `${praesenz.fachkompetenzen}\n${json.fachkompetenz}`
              } else {
                praesenz.fachkompetenzen = `${json.fachkompetenz}`
              }
            }
            if (json.fachkompetenz && !praesenz.fachkompetenzen)
              praesenz.fachkompetenzen = json.fachkompetenz

            if (json.sozialverhalten && praesenz.sozialverhalten !== null) {
              if (praesenz.sozialverhalten !== '') {
                praesenz.sozialverhalten = `${praesenz.sozialverhalten}\n${json.sozialverhalten}`
              } else {
                praesenz.sozialverhalten = `${json.sozialverhalten}`
              }
            }
            if (json.sozialverhalten && !praesenz.sozialverhalten)
              praesenz.sozialverhalten = json.sozialverhalten
          })
          this.speichern()
        }
      },
      kompetenzrasterDrucken(anmeldung) {
        let filename =
          'Kompetenzraster_' +
          anmeldung.person.personName.replace(/\s/g, '') +
          '_' +
          new Intl.DateTimeFormat('ch').format(new Date())
        this.pdfPath =
          server.url +
          `/pdfgenerator/pdf.act?filename=${filename}.pdf&report=/pdfgenerator/kompetenzraster.htm&ids=${anmeldung.id}&sgid=${anmeldung.kompetenzraster.id}&date=${anmeldung.veranstaltung.periodennummer}`

        this.$refs.pdfLayerAnwesenheit.show()
      },

      kompetenzrasterVorlageDrucken(anmeldung) {
        let filename =
          'KompetenzrasterVorlage_' +
          anmeldung.person.personName.replace(/\s/g, '') +
          '_' +
          new Intl.DateTimeFormat('ch').format(new Date())
        this.pdfPath =
          server.url +
          `/pdfgenerator/pdf.act?filename=${filename}.pdf&report=/pdfgenerator/kompetenzrasterVorlage.htm&ids=${anmeldung.id}&sgid=${anmeldung.kompetenzraster.id}&date=${anmeldung.veranstaltung.periodennummer}`

        this.$refs.pdfLayerAnwesenheit.show()
      },
      carboneExport() {
        // loading overlay start
        this.loading = true

        let params = {}

        let json = {
          termin: this.termin ? this.termin.id : null,
        }

        if (this.termin) params.termin = this.termin.id

        CarboneApi.post('carbone-anwesenheiten-export/', json, { params })
          .then((response) => {
            if (
              this.isDisplayableFile(response.data[0]?.url) === 'isWordFile'
            ) {
              $
              response.data.forEach((file) => {
                this.saveFile(
                  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                  file.url,
                  file.name,
                  '.docx'
                )
              })
            } else if (
              this.isDisplayableFile(response.data[0]?.url) === 'isExcelFile'
            ) {
              response.data.forEach((file) => {
                this.saveFile(
                  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  file.url,
                  file.name,
                  '.xlsx'
                )
              })
            } else {
              this.pdfFiles = response.data.map((item) => ({
                url: server.url + item.url,
                name: item.name,
                count: item.count,
                size: item.name,
              }))
              this.loading = false

              this.pdfFiles.length > 0
                ? this.$refs.pdfLayerAnmeldungReiter.show()
                : this.$notify({
                    type: 'warn',
                    title: this.$t('global.actionfailed'),
                    text: 'Es ist ein Fehler aufgetreten',
                  })
            }
          })
          .catch((e) => {
            this.$notify({
              type: 'warn',
              title: this.$t('global.actionfailed'),
              text: this.$t('global.exportfailed'),
            })
          })
          .finally(() => {
            this.loading = false
          })
      },

      isDisplayableFile(url) {
        const fileExtension = this.getFileExtension(url)
        if (['docx', 'doc'].includes(fileExtension)) {
          return 'isWordFile'
        } else if (['xls', 'xlsx', 'xlsm'].includes(fileExtension)) {
          return 'isExcelFile'
        }
        return 'isDisplayable'
      },
      getFileExtension(url) {
        const parts = url?.split('.')
        return parts[parts.length - 1].toLowerCase()
      },
      async saveFile(contentType, url, fileName, type) {
        if (!contentType || !url) return

        if (!fileName) fileName = 'Report'
        fileName = fileName + type

        const response = await fetch(Api.defaults.defaultURL + url, {
          headers: {
            'Content-Type': contentType,
          },
        })

        let file = await response.blob()
        FileDownload(file, fileName)
      },
      openSpracheWaehlenModal() {
        this.$bus.$emit('open-modal', 'praesenzliste-drucken-modal')
      },
      praesenzlisteDrucken(json) {
        const reportName = 'praesenzliste-' + json.language

        let [day, month, year] = this.datum.split('.')
        let jahr = year
        let filename =
          'Praesenzliste_' +
          this.veranstaltung.bezeichnung.replace(/\s/g, '') +
          '_' +
          day +
          '-' +
          month +
          '-' +
          year
        this.pdfPath =
          server.url +
          `/pdfgenerator/pdf.act?filename=${filename}.pdf&report=/pdfgenerator/${reportName}.htm&ids=${this.termin.id}&sgid=${this.veranstaltung.id}&date=${jahr}`

        this.$refs.pdfLayerAnwesenheit.show()
      },

      // Inhalt einer Reihe (Präsenz) auf alle anderen übertragen
      KompetenzenUndVerhaltenFuerAlleUebernehmen(selectedRow) {
        this.fachkompetenzAll = selectedRow.fachkompetenzen
        this.sozialverhaltenAll = selectedRow.sozialverhalten

        // allen rows diesen Inhalt zuordnen
        this.anwesenheit.forEach((row) => {
          row.fachkompetenzen = this.fachkompetenzAll
          row.sozialverhalten = this.sozialverhaltenAll
        })
        // beim Speichern alle neuen Inahlte übernehmen
        this.speichern()
      },
      // Jeder Präsenz wird das Attribut _showDetails gegeben, um die rowDeatails sichtbar zu machen
      expandAll() {
        for (const item of this.anwesenheit) {
          this.$set(item, '_showDetails', true)
        }
      },
      // Jeder Präsenz wird das Attribut _showDetails false gesetzt, um die rowDeatails zu verstecken.
      collapseAll() {
        for (const item of this.anwesenheit) {
          this.$set(item, '_showDetails', false)
        }
      },
    },
  }
</script>

<style></style>
